export var TransferProtocol;
(function (TransferProtocol) {
    TransferProtocol[TransferProtocol["Ftp"] = 1] = "Ftp";
    TransferProtocol[TransferProtocol["Http"] = 2] = "Http";
    TransferProtocol[TransferProtocol["Https"] = 3] = "Https";
})(TransferProtocol || (TransferProtocol = {}));
